window.Panel = (function () {
    // Params
    var options = {
        title: '',
        close: true, // Show close button
        buttons: [], // List of footer buttons
        class: '', // Custom panel class
        id: '', // Custom panel ID
        type: 'right', // [right, left]
        width: 'medium', // [small, medium, large]
        padding: true, // Wrap content with padding
        callback: function(){},
        beforeOpen: '',
        afterOpen: '',
        beforeClose: '',
        afterClose: ''
    };
    var selectors = {
        body: 'body',
        panel: '.sidepanel',
        content: '.sidepanel-content',
        header: '.sidepanel-header',
        footer: '.sidepanel-footer .sidepanel-wrapper',
        btnClose: '.sidepanel-close',
        loader: '.loader-logo',
        noFooter: '.sidepanel-no-footer',
        noPadding: '.sidepanel-no-padding',
        loaderInternal: '.loader-internal',
        overlay: '.sidepanel-overlay'
    };
    var sizes = {
        'small': '328px', // 328px - 32px (padding)
        'medium': '480px', // 480px - 32px (padding)
        'large': '720px' // 720px - 32px (padding)
    };
    var config = {
        timeout: 300,
        keyClose: 27,
        noFooter: 'sidepanel-no-footer'
    };
    var requestQueue = null;

    // Constructor
    var panel = function (customSettings) {
        var self = this;

        // Merge settings
        settings = $.extend({}, options, customSettings);

        // Init
        this.build(settings);
    };

    /**
     * Remove panel from DOM
     * @private
     */
    var _destroy = function() {
        $(selectors.panel).remove();
        $(document).unbind("keyup", _detectKey);
    };

    /**
     * Detect keyup
     * @param event
     * @private
     */
    var _detectKey = function(event) {
        var code = event.which;
        if (code == config.keyClose) {
            event.preventDefault();
            panel.prototype.close();
        }
    };

    /**
     * Construct DOM button
     * @param object button
     * @returns string
     * @private
     */
    var _addButton = function(button) {
        var btnClass = (undefined != button.class && '' != button.class) ? button.class : 'btn-default';
        var btnId    = (undefined != button.id && '' != button.id) ? 'id="'+button.id+'" ' : '';

        return '<a '+btnId+'href="#" class="btn ml-2 '+btnClass+'">'+button.name+'</a>';
    };

    /**
     * Add overlay before open
     * @private
     */
    var _addOverlay = function () {
        var overlay = '<div class="sidepanel-overlay"></div>';
        $('.global').append(overlay);
    };

    /**
     * Remove before close
     * @private
     */
    var _removeOverlay = function () {
        $(selectors.overlay).remove();
    };


    /**
     * Add event on button
     * @param object button
     * @returns function
     * @private
     */
    var _addAction = function(button) {
        return button.action;
    };

    /**
     * Hook before open
     * @private
     */
    var _beforeOpen = function() {
        _addOverlay();
        if ('' != settings.beforeOpen) {
            Utils.launch(settings.beforeOpen);
        }
    };

    /**
     * Hook after open
     * @private
     */
    var _afterOpen = function() {
        if ('' != settings.afterOpen) {
            Utils.launch(settings.afterOpen);
        }
    };

    /**
     * Hook before close
     * @private
     */
    var _beforeClose = function() {
        _removeOverlay();
        if ('' != settings.beforeClose) {
            Utils.launch(settings.beforeClose);
        }
    };

    /**
     * Hook after close
     * @private
     */
    var _afterClose = function() {
        if ('' != settings.afterClose) {
            Utils.launch(settings.afterClose);
        }
    };

    panel.prototype = {
        /**
         * Build DOM panel
         * @param object settings
         */
        build: function(settings) {
            var self        = this;
            var panelLayout = $(selectors.panel);

            // Clean panel
            if (panelLayout.hasClass('open')) {
                _destroy();
            }
            var title     = (settings.title) ? settings.title : "";
            var header    = '<h3 class="sidepanel-header px-3 my-0 pt-2 ellipsis" title="'+title+'">'+title+'</h3>';
            var noPadding = (settings.padding == false) ? ' sidepanel-no-padding' : '';
            var content   = '<div class="sidepanel-content sidepanel-no-footer'+noPadding+'"></div>';
            var footer    = '<div class="sidepanel-footer p-3 bt-1 hide"><div class="sidepanel-wrapper fright"></div></div>';
            var close     = (settings.close) ? '<a href="#" class="sidepanel-close"></a>' : '';
            var panelId   = (undefined != settings.id && '' != settings.id) ? 'id="'+settings.id+'" ' : '';
            panelLayout   = $('<div '+panelId+'class="sidepanel sidepanel-'+settings.type+' '+settings.class+'">'+close+''+header+''+content+''+footer+'</div>');

            // Add panel to DOM
            $(selectors.body).append(panelLayout);

            // Add styles
            $(selectors.panel).css('width', sizes[settings.width]).css(settings.type, '-'+sizes[settings.width]);

            // Add buttons
            var buttons = '';
            if (settings.buttons.length > 0) {
                for (var button in settings.buttons) {
                    var options = { id: '', class: '', name: '', action: '' };
                    settings.buttons[button] = $.extend({}, options, settings.buttons[button]);
                    var html = _addButton(settings.buttons[button]);
                    var btn  = $(html);
                    $(selectors.footer).append(btn);
                    btn.on('click', _addAction(settings.buttons[button]));
                }
            }

            // Events
            $(selectors.panel).find(selectors.btnClose).on('click', function (event) {
                event.preventDefault();
                self.close();
            });
            if (settings.close) {
                $(document).on('keyup', _detectKey);
            }
        },
        /**
         * Open panel
         * @param string route
         * @param object params
         */
        open: function(route, params) {
            var self  = this;

            _beforeOpen();
            
            $('.preview_nomsie embed').addClass('hidden'); // document
            $('#content_preview embed').addClass('hidden'); // proposal

            // Open pannel
            setTimeout(function() {
                if (undefined == settings.buttons || '' == settings.buttons || 0 == settings.buttons.length) {
                    $(selectors.content).removeClass(config.noFooter);
                }
                $(selectors.panel).addClass('open');
                self.loading();
            }, 100);

            setTimeout(function() {
                if (null != requestQueue) {
                    requestQueue.abort(function () {
                        requestQueue = null;
                    });
                }
                // Call ajax
                requestQueue = MyFacture.post(route, params, function(data) {
                    // Callback
                    $(selectors.content).html(data);
                    $(selectors.panel).addClass('sidepanel-loaded');
                    MyFacture.customForm(undefined, false);
                    Utils.launch(settings.callback(data));
                    if (settings.buttons.length > 0) {
                        $(selectors.footer).parent().removeClass('hide');
                    }
                    _afterOpen();
                }, "html", true);
            }, config.timeout);

            //Exception when display agenda popin
            const popupAgenda = $("#popupAgenda");
            const zindex = parseInt(popupAgenda.css("z-index"));
            if(popupAgenda && !!zindex){
                $($(".sidepanel, .agenda, .open")[1]).css({"z-index": zindex + 1});
            }
        },
        /**
         * Close panel
         */
        close: function() {
            if ($('.sidepanel').length && $('.sidepanel').is(':visible')) {

                $('.preview_nomsie embed').removeClass('hidden'); // document
                $('#content_preview embed').removeClass('hidden'); // proposal

                _beforeClose();
                $(selectors.panel).removeClass('open');
                setTimeout(function() {
                    _destroy();
                    _afterClose();
                }, config.timeout);

                //Exception when display agenda popin
                const popupAgenda = $("#popupAgenda");
                const zindex = parseInt(popupAgenda.css("z-index"));
                if(popupAgenda && !!zindex){
                    $($(".sidepanel, .agenda, .open")[1]).css({"z-index": zindex - 1});
                }
            }
        },

        /**
         * Show/hide loader
         * @param bool show
         * @param bool internal
         */
        loading: function(show, internal) {
            var show     = (undefined == show) ? true : show;
            var internal = (undefined == internal) ? false : internal;
            if (show) {
                var loading = MyWindow.getLoader();
                if (internal) {
                    loading = '<div class="loader-internal">'+loading+'</div>';
                    $(selectors.content).append(loading);
                } else {
                    $(selectors.content).html(loading);
                }
            } else {
                $(selectors.loader).remove();
                if ($(selectors.loaderInternal).length) {
                    $(selectors.loaderInternal).remove();
                }
            }
        },
        /**
         * Set tiitle
         * @param string title
         */
        setTitle: function(title) {
            $(selectors.header).html(title).attr('title', title);
        },
        /**
         * Add button
         * @param object button
         * @param string position
         */
        addButton: function(button, position) {
            var position = (undefined == position) ? 'right' : position;
            var html = _addButton(button);
            var btn  = $(html);
            if ('right' == position) {
                $(selectors.footer).append(btn);
            } else {
                $(selectors.footer).prepend(btn);
            }
            btn.on('click', _addAction(button));
            $(selectors.footer).parent().removeClass('hide');
        },
        /**
         * Remove button (by jquery selector)
         * @param string selector
         */
        removeButton: function(selector) {
            if ($(selector).length) {
                $(selectors.panel).find(selector).remove();
            }
            setTimeout(function() {
                if ($(selectors.footer).children().length == 0) {
                    $(selectors.footer).parent().addClass('hide');
                }
            }, 100);
        }
    };

    return panel;
})();